import React, { Component } from 'react'
import { Button, Col, Form, Icon, Upload } from 'antd'
import { compose } from 'recompose'
import { get, isEmpty } from 'lodash'
import OrganisationsSelect from '../../../../../elements/Select/Organistaions'
import withData from '../../../../../elements/Select/withData'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import { rules } from '../../../../../modules/FormItems'
import CurrencySelect from '../../../../../elements/Select/Currency'
import withSort from '../../../../../elements/HOC/withSort'

const BankTemplateSelect = withData({
  data: [
    { key: 'bsp', value: 'BSP' },
    { key: 'rhb', value: 'RHB' },
    { key: 'nbad', value: 'NBAD' },
    { key: 'endb', value: 'ENDB' },
    { key: 'dbs', value: 'DBS' },
    { key: 'hsbc', value: 'HSBC' },
    { key: 'nba', value: 'NBA' },
    { key: 'lloyds', value: 'Lloyds' },
    { key: 'macquarie', value: 'Macquarie CC' },
    { key: 'starling', value: 'Starling Bank' },
  ],
  withSort,
})(CustomSelect)

class TransactionUploadForm extends Component {
  render() {
    const {
      onFileLoaded,
      csvFileList,
      transactionUploadList,
      beforeUpload,
      details,
      BankSelectCmp,
      onChangeCompany,
    } = this.props
    const { getFieldDecorator, getFieldValue } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14, offset: 1 },
      },
    }
    const props = {
      onChange: onFileLoaded,
      beforeUpload: (file) => beforeUpload(file, getFieldValue('template')),
      fileList: csvFileList,
    }
    return (
      <Form>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Company'}>
            {getFieldDecorator('company._id', {
              initialValue: get(details, 'company._id'),
              rules: [{ required: true, message: 'Please Select a Company!' }],
            })(<OrganisationsSelect onChange={onChangeCompany} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Bank Account'}>
            {getFieldDecorator('bank._id', {
              initialValue: get(details, 'bank._id'),
              rules: [{ required: true, message: 'Please Select a Bank!' }],
            })(
              <BankSelectCmp style={{ width: '100%' }} keyAtr={'_id'} valueAtr={'title'} placeholder={'Bank Account'} />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Bank Template'}>
            {getFieldDecorator('template', {
              initialValue: get(details, 'template'),
              rules: [{ required: true, message: 'Please Select a Bank Template !' }],
            })(<BankTemplateSelect style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        {['dbs', 'hsbc'].includes(getFieldValue('template')) && (
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Currency'}>
              {getFieldDecorator('currency', {
                initialValue: get(details, 'currency'),
                rules: rules.select,
              })(<CurrencySelect />)}
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'File'}>
            {getFieldDecorator('file', {
              rules: [{ required: true, message: 'Please Select a File!' }],
            })(
              <Upload {...props} disabled={!getFieldValue('template')}>
                <Button disabled={!getFieldValue('template')}>
                  <Icon type="upload" /> Select File
                </Button>
              </Upload>
            )}
            {transactionUploadList.length > 0 && (
              <span>{`Records to be uploaded ${transactionUploadList.length}`}</span>
            )}
          </Form.Item>
        </Col>
      </Form>
    )
  }
}

TransactionUploadForm.propTypes = {}
TransactionUploadForm.defaultProps = {}

export default compose(Form.create())(TransactionUploadForm)
